// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/contact-request-schema',
  type: 'object',
  required: ['salutation', 'firstName', 'lastName', 'phoneNumber', 'email'],
  properties: {
    salutation: {
      enum: [
        0,
        1,
        2,
      ],
    },
    firstName: {
      type: 'string',
      minLength: 1,
    },
    lastName: {
      type: 'string',
      minLength: 1,
    },
    phoneNumber: {
      type: 'string',
      minLength: 1,
    },
    email: {
      type: 'string',
      minLength: 1,
    },
  },
} as IJSONSchema;

export default schema;
